<template>
	<div
		class="layout activity-layout"
	>
		<v2-app-header mini />

		<transition
			name="fade"
		>
			<loading
				v-show="getLoadingIsVisible"
			/>
		</transition>

		<transition name="fade" mode="out-in">
			<component
				:is="getRouteComponent"
				:key="$route.fullPath"
			/>
		</transition>

		<notification />
		<V2LessonNav />
		<modal />
	</div>
</template>

<script>

	import AppLogo       from '@/components/ui/header/AppLogo';
	import Breadcrumbs   from '@/components/ui/Breadcrumbs';
	import Loading       from '@/components/ui/Loading';
	import Notification  from '@/components/ui/Notification';
	import FourOhFour    from '@/pages/404';
	import V2LessonNav     from '@/components/lesson/lessonNav/V2LessonNav';
	import NavButton     from '@/components/lesson/lessonNav/NavButton';
	import Modal         from '@/components/ui/modal/Modal';
	import routeParams   from '@/mixins/routeParams';
	import V2AppHeader from '@/components/v2/header/V2AppHeader';

	export default {
		components: {
			AppLogo,
			Breadcrumbs,
			Loading,
			FourOhFour,
			Notification,
			V2LessonNav,
			NavButton,
			Modal,
			V2AppHeader
		},
		mixins: [routeParams],
		computed: {
			getErrorIsVisible () {
				return this.$store.getters['ui/getErrorIsVisible'];
			},
			getLoadingIsVisible () {
				return this.$store.getters['ui/getLoadingIsVisible'];
			},
			getShowBreadcrumbs () {
				if (this.getContext !== 'admin' &&
						this.getContext !== 'teaching') {
					return false;
				}
				return true;
			},
			getRouteComponent () {
				if (this.$store.getters['ui/getErrorIsVisible']) {
					return 'FourOhFour';
				}
				return 'router-view';
			}
		},
		methods: {}
	};

</script>

<style lang="scss" scoped>
.activity-layout {
  .container {
    margin: 0 2.25rem;
    max-width: -webkit-fill-available;
  }

  .page {
    padding-top: 0;
  }
}

	[data-layout='activity'] {
		position:relative;
		display:flex;
		flex-direction:column;
		min-height:100vh;
		background-color:$c-white;
		&:before {
			content:'';
			position:absolute;
			z-index:-1;
			top:12px;
			right:12px;
			bottom:12px;
			left:12px;
			display:block;
			border:4px solid $c-brand-blue;
			border-radius:4px;
			pointer-events:none;
		}
		&:after {
			content:'';
			position:absolute;
			z-index:-1;
			top:19px;
			right:19px;
			bottom:19px;
			left:19px;
			display:block;
			border:2px solid $c-brand-red;
			pointer-events:none;
		}
		&[data-error] {
			@include grid-container;
			padding-top:rem(64);
		}
		header {
			position:fixed;
			top:rem(36);
			left:rem(36);
			right:auto;
			display:flex;
			align-items:center;
			[data-component='app-logo'] {
				margin-right:rem(48);
				flex-shrink:0;
			}
			[data-component='breadcrumbs'] {
				display:none;
				@include mq('sm') {
					display:block;
				}
				margin:auto rem(64) auto 0;
			}
		}
		[data-component='loading'] {
			top:0; right:0; bottom:0; left:0;
			width:100vw; height:100vh;
		}
		[data-component='nav-button'] {
			position:fixed;
			top:rem(28);
			right:rem(28);
		}
		[data-component='btn'] {
			position:fixed;
			bottom:rem(24);
			right:rem(24);
		}
	}
</style>
